import { render, staticRenderFns } from "./TextModelSwitch.vue?vue&type=template&id=65193558&scoped=true&"
import script from "./text-model-switch.js?vue&type=script&lang=js&"
export * from "./text-model-switch.js?vue&type=script&lang=js&"
import style0 from "./text-model-switch.scss?vue&type=style&index=0&id=65193558&prod&lang=scss&scoped=true&"
import style1 from "./global.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65193558",
  null
  
)

export default component.exports